import { useState, useEffect, useCallback, useRef } from "react";
import DynamicTable from "../../ui/DynamicTable";
// import { userSession } from "../observers/userObserver";
import config from "../../../config/config";
import { refreshCustomerTableData } from "../../../observers/dataObserver";
import { BsThreeDotsVertical } from "react-icons/bs";
import { CustomerTableFactory } from "../../../factory/customerFactory";
import Pagination from "../../ui/Pagination";
import { formatDateTime } from "../../../utils/utils";
import { userSession } from "../../../observers/userObserver";
import { CODInput } from "../../ui/CODinput"; // adjust path if needed

const CustomerTable = ({ onCustomerView, onCustomerEdit }) => {
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState({
    company_name: ""
  });
  const [appliedFilters, setAppliedFilters] = useState({
    company_name: ""
  });

  const [pagination, setPagination] = useState({
    current_page: 1,
    total_items: 0,
    total_pages: 0,
    limit: 10
  });
  const dropdownRef = useRef(null);

  const token = userSession.getToken();

  const getAuthHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  });

  const handlePageChange = (pageNumber) => {
        setPagination((prevPagination) => ({
            ...prevPagination,
            current_page: pageNumber
        }));
    };

  const fetchCustomers = useCallback(async () => {
    try {
      let url = `${config["backend-url"]}/v2/get_all_customers?page=${pagination.current_page}&limit=${pagination.limit}`;

      if (appliedFilters.company_name) {
        url += `&company_name=${encodeURIComponent(appliedFilters.company_name)}`;
      }

      const response = await fetch(url, {
            method: "GET",
            headers: getAuthHeaders()
        });

      const data = await response.json();

      console.log("Raw API response:", data);

      const formattedData = data.data.map((item, index) => {
        console.log("Customer item AISearchEnabled:", item.AISearchEnabled, "AI_Search_Enabled:", item.AI_Search_Enabled);
        const formatted = CustomerTableFactory(item);
        console.log("Formatted item aiSearch:", formatted.aiSearch);
        return formatted;
      });
      setRows(formattedData);
      console.log("Formatted customer data with aiSearch:", formattedData.map(d => ({ customerName: d.customerName, aiSearch: d.aiSearch })));
      setPagination(data.pagination);
    } catch (err) {
      console.error("❌ Error fetching customers:", err.message || err);
    } finally {
    }
  }, [pagination.current_page, pagination.limit, appliedFilters, token]);

  useEffect(() => {
    fetchCustomers();

    refreshCustomerTableData.subscribe((value) => {
      if (value === "refresh") {
        fetchCustomers();
      }
    });

  }, [fetchCustomers]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen({});
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleFilterChange = (value) => {
    setFilters({ company_name: value });
  };

  const handleApplyFilters = () => {
    setAppliedFilters(filters);
    setPagination((prev) => ({ ...prev, current_page: 1 }));
  };

  const handleResetFilters = () => {
    setFilters({ company_name: "" });
    setAppliedFilters({ company_name: "" });
    setPagination((prev) => ({ ...prev, current_page: 1 }));
  };

  const toggleDropdown = useCallback((id) => {
    setDropdownOpen((prev) => {
        const isOpen = prev[id];
        return isOpen
        ? {} // Close all if current is open
        : { [id]: true }; // Open only the current one
    });
},[]);

const renderStatus = useCallback((value) => (
        <span className={`status-tile status-${value ? "active" : "inactive"}`}>
          {value ? "Active" : "Inactive"}
        </span>
    ),[]);

const renderAISearch = useCallback((value) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          {value ? (
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="18" height="18" rx="3" fill="#07b1b0"/>
              <path d="M14 6L7.5 12.5L4 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="18" height="18" rx="3" fill="none" stroke="#d1d5db" strokeWidth="2"/>
            </svg>
          )}
        </div>
    ),[]);

const renderEndDate = useCallback((value) => (
    formatDateTime(value, "%d/%m/%Y")
), []);

  const renderActionDropdown = useCallback((_, row) => {
    return (
        <div className="dropdown-container" key={row.customerId} ref={dropdownOpen[row.customerId] ? dropdownRef : null}>
        <button
            onClick={() => toggleDropdown(row.customerId)}
            className="dropdown-btn"
        >
            <BsThreeDotsVertical size={20} />
        </button>
        {dropdownOpen[row.customerId] && (
            <div className="custom-dropdown">
                <div
                    className="dropdownItem"
                    onClick={() => onCustomerView(row)}
                >
                    View
                </div>
                <div
                    className="dropdownItem"
                    onClick={() => onCustomerEdit(row)}
                >
                    Edit
                </div>
            </div>
        )}
        </div>
    );
    },[onCustomerEdit, onCustomerView, dropdownOpen, toggleDropdown, dropdownRef]);

  const columns = [
    { key: "customerName", label: "Customer" },
    { key: "country", label: "Country" },
    { key: "status", label: "Status", render: renderStatus },
    { key: "aiSearch", label: "AI Search", render: renderAISearch },
    { key: "subscriptionPlan", label: "Subscription "},
    { key: "customerEndDate", label: "Renews", render: renderEndDate },
    { key: "adminUserEmail", label: "Admin" },
    { key: "action", label: "Action ", render: renderActionDropdown }
  ];

  return (
    <>
    <div
  style={{
    marginBottom: "1rem",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    gap: "10px",
  }}
>
  <CODInput
    label="Filter by Company Name"
    name="companyFilter"
    value={filters.company_name}
    onChange={(e) => handleFilterChange(e.target.value)}
    placeholder="Enter company name"
  />

  <button
    onClick={handleApplyFilters}
    style={{
      backgroundColor: "#07b1b0",
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      padding: "8px 16px",
      cursor: "pointer",
      fontWeight: "500",
    }}
  >
    Filter
  </button>

  <button
    onClick={handleResetFilters}
    style={{
      backgroundColor: "#ccc",
      color: "#000",
      border: "none",
      borderRadius: "6px",
      padding: "8px 16px",
      cursor: "pointer",
      fontWeight: "500",
    }}
  >
    Reset
  </button>
</div>

        <DynamicTable data={rows} columns={columns} />
        <Pagination totalPages={pagination.total_pages} page={pagination.current_page} handlePageChange={handlePageChange} />
    </>
  );
};

export default CustomerTable;
